﻿import window from 'window';
import { isMobile } from '../../utilities/is-mobile';
import { debounce } from '../../utilities/debounce';

export const contentToggle = () => {

    const selectors = {
        accessibilityExpand: 'aria-expanded'
    };

    const toggleAttibute = (elem, attribute) => {
        const isOn = elem.getAttribute(attribute) === 'true';

        if (isOn) {
            elem.removeAttribute(attribute);
        } else {
            elem.setAttribute(attribute, 'true');
        }
    };

    const init = component => {

        const onClick = e => {
            e.preventDefault();
            toggleAttibute(component, selectors.accessibilityExpand);
        }
        
        const onResize = debounce(() => {
            component.removeEventListener('click', onClick);

            if (isMobile(579)) {
                component.addEventListener('click', onClick);
            }
        }, 100);

        window.addEventListener('load', onResize);
        window.addEventListener('resize', onResize);
    };

    return {
        init: init,
        selector: '[data-component="content-toggle"]'
    };
};